<template>
  <div>
    <div class="landing center" style="">
      <img style="padding-top: 25vh; width: 80%; max-width: 600px;" class="center" src="../assets/img/logo/GoldCoastNannies_Logo_FullColor-01.png" alt="">
      <div class="grouped-buttons" style="margin-top: 35px; margin-bottom: 25px;">
        <router-link class="mylisting-button dark-button mb-2" :to="{ name: 'Candidate Application Form' }">Nanny Application Form</router-link>
        <router-link class="mylisting-button dark-button mb-2" :to="{ name: 'Employer Application Form' }">Family Application Form</router-link>
      </div>
      <img class="mt-3" src="../assets/img/general/testimonialsflowers_trim.png" alt="">
    </div>

  </div>

</template>

<style >

  /* https://stackoverflow.com/questions/18901819/how-to-show-full-height-background-image */
  /* https://css-tricks.com/perfect-full-page-background-image/ */

  .landing {
    background-color: #eeebe2;
    /* height:100%; */
    height: 100vh;
    /* padding-left: 5%; */
    /* padding-right: 5%; */
    /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
    /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
    /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
    /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
    /* background: url('../assets/img/landing/hero.jpg') center center; */
    /* background-size: auto 100%; */
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
    /* background-position: left top; */
  }

  @media (max-width: 768px) {

  }

</style>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        showstep1: false,
        showstep2: false,
        showstep3: false,
        showstep4: false,
        show: false,

        editing: false,
        pageTemplate: {},
        heroText: '',
      }
    },
    created() {
      // this.getPageTemplate()
    },
    methods: {
      // getPageTemplate() {
      //   axios.get('/api/nannyhomepages/1')
      //     .then(res => {
      //       this.pageTemplate = res.data
      //       this.heroText = this.pageTemplate.hero_text
      //     })
      // },
      // updateTemplate() {
      //   axios.patch('/api/nannyhomepages/1/', {
      //     hero_text: this.heroText
      //   })
      //     .then(res => {
      //       this.getPageTemplate()
      //       this.editing = false
      //     })
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Landing.vue